var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-third btn-sm",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.deleting.apply(null, arguments)}}},[_c('i',{staticClass:"icofont icofont-close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }